import { render, staticRenderFns } from "./OpenBusinessPlan.vue?vue&type=template&id=13b62563&scoped=true"
import script from "./OpenBusinessPlan.vue?vue&type=script&lang=js"
export * from "./OpenBusinessPlan.vue?vue&type=script&lang=js"
import style0 from "./OpenBusinessPlan.vue?vue&type=style&index=0&id=13b62563&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b62563",
  null
  
)

export default component.exports